import React, { useEffect, useLayoutEffect, useState } from "react";
import { Button, Divider, Drawer } from "@mui/material";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import Loading from "../common/Loading";
import DetallePuesto from "../cargas/DetallePuesto";
import Marquesina from "../cargas/Marquesina";
import Leyenda from "../cargas/Leyenda";
import _ from "lodash";
import Headroom from "react-headroom";
//redux
import { connect } from "react-redux";
import { fetchBuses } from "../../redux/actions/buses";
import { changeChargerStatus } from "./../../redux/actions/cambiaEstados";
import {
  isAppLocked,
  setLoading,
  setUnloading,
} from "./../../redux/actions/global";
import { signInDTPM } from "./../../redux/actions/index";
import {
  setIntervalFetchMarquesinas,
  unsetIntervalFetchMarquesinas,
  fetchMarquesinasDTPM,
  setDataModal,
  unsetDataModal,
  updateModalData,
  toggleBtnModal,
  getStatusConnetor,
  getStatusConnectorAll,
  fetchInnerStateChargers,
  stopChargeInternally,
  stopChargerOnFailure,
  stopPendingChargings,
  setChargerFree,
  setChargerOperativo,
  handleInspectCharger,
  handleSync,
  reservaNuevamente,
} from "./../../redux/actions/cargas";

const IndexDTPM = ({
  signInDTPM,
  isLoading,
  auth,
  marquesinas,
  setIntervalFetchMarquesinas,
  unsetIntervalFetchMarquesinas,
  fetchInnerStateChargers,
  getStatusConnetor,
  setUnloading,
}) => {
  const [terminalId, setTerminalId] = useState(
    window.location.pathname.split("/")[3]
  );

  useEffect(() => {
    let intervalId = 0;
    obtieneMarquesinas();
    //fetchBuses();
    intervalId = setInterval(() => {
      obtieneMarquesinas();
      //isAppLocked();
    }, 5000);

    setIntervalFetchMarquesinas(intervalId);
    fetchInnerStateChargers();

    return () => {
      console.log("se elimino intervalo de marquesinas");
      clearInterval(intervalId);
      unsetIntervalFetchMarquesinas(intervalId);
    };
  }, []);

  const obtieneMarquesinas = async () => {
    //await fetchMarquesinasDTPM();
    //if (terminalId != 1) {
    signInDTPM(parseInt(terminalId));
    //}
    setUnloading();
  };

  //establece detalles en drawer
  const handleDetalle = async (puesto, marquesina, cargadorOrigen) => {
    /* setActualizaModal(true);
    setDataModal(puesto, marquesina, cargadorOrigen); */
  };

  //cierra y limpia drawer
  const handleClose = () => {
    /*     setActualizaModal(false);
    unsetDataModal(); */
  };

  //acciona pistola
  const handlePistola = (dataModal, estado) => {
    /*     toggleBtnModal();
    handleTecle(dataModal, estado); */
  };

  //libera puesto
  const handleLiberaPuesto = (dataModal) => {
    /*     setChargerFree(dataModal); */
  };

  //coloca puesto a ocupado
  const handleSetPuestoOperativo = (dataModal, errorId, socket) => {
    //setChargerOperativo(dataModal, errorId, socket);
  };

  //detenciones de cargas internamente
  const handleDetieneCargaInterna = (dataModal) => {
    //stopChargeInternally(dataModal);
  };

  //obtencion de conector status
  const obtieneConnectorStatus = (data) => {
    return getStatusConnetor(data);
  };

  //sincroniza cargador
  const handleSyncCargador = (
    cargadorId,
    marquesinaId,
    puestoId,
    puestoNombre
  ) => {
    /*     handleSync(cargadorId, marquesinaId, puestoId, puestoNombre);
    setActualizaModal(false); */
  };

  //establece inspeccion en puesto
  const handleInspeccionaPuesto = (
    dataModal,
    puestoId,
    puestoNombre,
    enInspeccion
  ) => {
    //handleInspectCharger(dataModal, puestoId, puestoNombre, enInspeccion);
  };

  //reserva nuevamente
  const handleReservaNuevamente = (dataModal, errorId, socket) => {
    /* reservaNuevamente(dataModal, errorId, socket);
    handleClose(); */
  };

  //detiene cargas ante averia
  const handleDetienCargaOnAveria = (
    marquesinaId,
    cargadorId,
    puestoId,
    ppu
  ) => {
    /* console.log("Se detuvo una carga por averia", puestoId, ppu);
    stopChargerOnFailure(marquesinaId, cargadorId, puestoId, ppu); */
  };

  //contador de cargadores

  const setCounter = () => {
    let pistolasTodas = [];
    marquesinas.map((marquesina) =>
      marquesina.cargadores.map((cargadores) =>
        cargadores.pistolas.map((pistolas) => {
          pistolasTodas = [...pistolasTodas, pistolas];
        })
      )
    );

    const countDisponibles = pistolasTodas.filter(
      (pistola) => pistola.estado === 1
    ).length;
    const countReservados = pistolasTodas.filter(
      (pistola) => pistola.estado === 2
    ).length;
    const countCargando = pistolasTodas.filter(
      (pistola) => pistola.estado === 3
    ).length;
    const countOcupados = pistolasTodas.filter(
      (pistola) => pistola.estado === 4
    ).length;
    const countInhabilitados = pistolasTodas.filter(
      (pistola) => pistola.estado === 5
    ).length;
    const countOperativo = pistolasTodas.filter(
      (pistola) => pistola.estado === 6
    ).length;
    return {
      countDisponibles,
      countReservados,
      countCargando,
      countOcupados,
      countInhabilitados,
      countOperativo,
    };
  };

  return isLoading ? (
    <Loading label="Cargando Marquesinas..." />
  ) : (
    <>
      <Headroom>
        <Leyenda data={setCounter()} />
      </Headroom>
      <Grid2 container>
        <Grid2 md={12} xs={12}>
          {marquesinas.map((marquesina, index) => (
            <React.Fragment key={index}>
              <Marquesina
                marquesina={marquesina}
                indexMarquesina={index}
                onClick={handleDetalle}
                onDetienCargaOnAveria={handleDetienCargaOnAveria}
                opcionesVisible={true}
              />
              {index === 1 && auth.userData.terminal.id === 2 && (
                <Divider sx={{ borderWidth: 60 }} />
              )}
            </React.Fragment>
          ))}
        </Grid2>
      </Grid2>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    isBtnAppLocked: state.global.isAppLocked,
    isLoading: state.global.loading,
    auth: state.auth,
    intervalId: state.cargas.intervalId,
    marquesinas: state.cargas.marquesinas,
    modalData: state.cargas.modalData,
    statusConnector: state.cargas.statusConnector,
    statusConnectorAll: state.cargas.statusConnectorAll,
    cargadoresEstadoInterno: state.cargas.cargadoresEstadoInterno,
  };
};

export default connect(mapStateToProps, {
  signInDTPM,
  isAppLocked,
  fetchMarquesinasDTPM,
  fetchBuses,
  getStatusConnectorAll,
  stopPendingChargings,
  setIntervalFetchMarquesinas,
  unsetIntervalFetchMarquesinas,
  fetchInnerStateChargers,
  setDataModal,
  unsetDataModal,
  toggleBtnModal,
  setChargerFree,
  setChargerOperativo,
  stopChargeInternally,
  getStatusConnetor,
  handleSync,
  reservaNuevamente,
  handleInspectCharger,
  changeChargerStatus,
  stopChargerOnFailure,
  updateModalData,
  setUnloading,
  setLoading,
})(IndexDTPM);
